import React, { useState, useEffect } from "react";

import Cube from "./cube";

import { cubeList } from "../lib/cubeList";

import { useMeasurements } from "components/shipment-editor/measurements/hooks/use-measurements";

import * as notify from "../../../shared/notify";
import NotificationBar from "../../notification-bar";

const checkMatch = (dimensions, selectedMeasurement) => {
    let isMatch = true;
    Object.keys(dimensions).forEach((key) => {
        if (dimensions[key].toString() !== selectedMeasurement[key].value.toString()) {
            isMatch = false;
        }
    });

    return isMatch;
};

const LayoutSelector = (props) => {
    const { measurementState, saveMeasurement } = useMeasurements();
    const isCompleted = measurementState.isCompleted;
    const [hasMismatchedUom, setHasMismatchedUom] = useState(false);

    useEffect(() => {
        const { width, height, depth } = props.selectedMeasurement;
        setHasMismatchedUom(!(width.uom === height.uom && width.uom === depth.uom));
    }, [props.selectedMeasurement]);

    const sortByPattern = (pattern) => {
        const height = props.selectedMeasurement.height.value || 0;
        const width = props.selectedMeasurement.width.value || 0;
        const depth = props.selectedMeasurement.depth.value || 0;

        const values = [height, width, depth].sort((a, b) => {
            return b - a;
        });

        const patternArr = pattern.split("-");

        return values.reduce((memo, r, i) => {
            const patternTemp = patternArr[i];

            if (patternTemp === "H") {
                memo.height = r;
            } else if (patternTemp === "W") {
                memo.width = r;
            } else if (patternTemp === "D") {
                memo.depth = r;
            }

            return memo;
        }, {});
    };

    const rotateMeasurement = async (item) => {
        if (isCompleted) {
            return;
        }

        if (!props.selectedMeasurement || props.selectedMeasurement < 0) {
            notify.error(`Please select a measurement`);

            return;
        }

        const newValues = sortByPattern(item.pattern);

        const newMeasurement = { ...props.selectedMeasurement };

        newMeasurement.height = { value: newValues.height, uom: newMeasurement.height.uom };
        newMeasurement.width = { value: newValues.width, uom: newMeasurement.width.uom };
        newMeasurement.depth = { value: newValues.depth, uom: newMeasurement.depth.uom };

        const hasSaved = await saveMeasurement(measurementState, newMeasurement, true, props.sourcePage);

        if (hasSaved) {
            notify.success("Saved");
        }
    };

    const renderItem = (item) => {
        const dimensions = sortByPattern(item.pattern);
        const isMatch = checkMatch(dimensions, props.selectedMeasurement);
        const cssClass = isMatch ? "button -active" : "button";

        return (
            <li
                key={item.id}
                className={cssClass}
                onClick={() => rotateMeasurement(item)}
            >
                <Cube
                    dimensions={dimensions}
                    selectedMeasurement={props.selectedMeasurement}
                    isMatch={isMatch}
                />
                <span>{item.label}</span>
            </li>
        );
    };

    const items = props.selectedMeasurement || props.selectedMeasurement > 0 ? cubeList.map(renderItem) : null;

    return (
        <div>
            {hasMismatchedUom && (
                <NotificationBar
                    type="info"
                    message="The selected measurement has a mismatched unit of measure. The layouts below may not represent the actual shape of the package."
                />
            )}
            <ul className="measurement-detail-list">{items}</ul>
        </div>
    );
};

export default LayoutSelector;
